import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import UserData from 'src/modules/user/types/user';

@Component({
    selector: 'resset-user-password',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    standalone: false
})
export class ResetUserPassword implements OnInit {
  public loading: boolean;
  public submitted = false;

  public userId: number;
  public email:string;

  constructor(
    protected dialogRef: MatDialogRef<ResetUserPassword>,
    @Inject(MAT_DIALOG_DATA)
    private readonly data: UserData
  ) {}

  ngOnInit(): void {
 this.email = this.data.User.email;
  }

  onSubmit() {
    const { dataSource } = this.data as UserData;
    this.loading = true;

    dataSource
      .save(this.data.User)
      .then(() => this.dialogRef.close())
      .finally(() => (this.loading = false));
  }
}
